export const getQueryValueFromString = (
  str: string | undefined,
  param: string
): string | undefined => {
  if (!str) return
  const results = new RegExp('[\\?&]' + param + '=([^&#]*)').exec(str)
  if (!results) return
  return results[1] || undefined
}
